import SearchResultsTable from './SearchResultsTable';

export default SearchResultsTable;
